import type { ClientPortfolioManualValueSaveRequestDTO } from "web_myplann/Infrastructure/Api/Api";
import type { ManualValueFormOutput } from "web_myplann/Portfolio/PortfolioShared/ManualValue/manualValueFormTypes";

export const mapManualValueToRequest = ({
	value,
	invested,
	valueDate,
}: ManualValueFormOutput):
	| ClientPortfolioManualValueSaveRequestDTO
	| undefined =>
	value === null ? undefined : { value, invested, date: valueDate };
